import React from "react";
import { Label } from "./ui/label";
import { useTranslation } from "react-i18next";

export function UpgradeLabel() {
  const { t } = useTranslation();

  return (
    <Label className="cursor-pointer p-1 rounded bg-yellow-500 text-white text-xs">
      {t("Upgrade")}
    </Label>
  );
}
